import React, { CSSProperties, useEffect, useState } from 'react';

import { SkinThemeProvider } from '../../shared/SkinThemeContext';
import SkinThemeService from '../../shared/services/SkinThemeService';
import { ThemeProvider } from '@mui/material/styles';
import useThemes from '../../shared/hooks/useThemes';

interface WithThemingProps {
  children: JSX.Element;
}

const WithTheming = (props: WithThemingProps) => {
  const { skinTheme, muiTheme } = useThemes();
  const [dashboardStyle, setDashboardStyle] = useState<CSSProperties>();

  useEffect(() => {
    const style = {
      backgroundColor: SkinThemeService.getThemeOptionValue(
        skinTheme,
        'dashboard',
        'backgroundColor'
      ) as string,
      backgroundImage: `url(${SkinThemeService.getAssetUrl(
        'dashboard',
        'backgroundImage'
      )})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundAttachment: 'fixed'
    };
    setDashboardStyle(style);
  }, [skinTheme]);

  return (
    <div className="dashboard-container" style={dashboardStyle}>
      <ThemeProvider theme={muiTheme}>
        <SkinThemeProvider value={skinTheme}>
          <div className="dashboard-body">{props.children}</div>
        </SkinThemeProvider>
      </ThemeProvider>
    </div>
  );
};

export default WithTheming;
